import VueRouter from 'vue-router';
import HomePage from "@/views/HomePage"
import UserAgreement from "@/views/UserAgreement"
import ScanVerify from "@/views/ScanVerify/ScanVerify";
import VerifyRecord from "@/views/ScanVerify/VerifyRecord";
import VerifyRecordDetail from "@/views/ScanVerify/VerifyRecordDetail";
import VerifyResult from "@/views/ScanVerify/VerifyResult";
import SporadicCharges from "@/views/ScanVerify/SporadicCharges";
import RichScan from "@/views/ScanVerify/RichScan";
import ChargeCode from "@/views/ScanVerify/ChargeCode";
import ChargePhone from "@/views/ScanVerify/ChargePhone";
import ChargePay from "@/views/ScanVerify/ChargePay";
import ChargeResult from "@/views/ScanVerify/ChargeResult";
import ChargeInvoice from "@/views/ScanVerify/ChargeInvoice";
import MyElectronicPass from "@/views/MyElectronicPass/MyElectronicPass";
import ChoiceProject from "@/views/MyElectronicPass/ChoiceProject";
import ChoiceSubject from "@/views/MyElectronicPass/ChoiceSubject";
import ChoiceSubSubject from "@/views/MyElectronicPass/ChoiceSubSubject";
import ConstructionLocation from "@/views/MyElectronicPass/ConstructionLocation";
import DecorationPersonnelInformation from "@/views/MyElectronicPass/DecorationPersonnelInformation";
import DigitalPassApplications from "@/views/DigitalPassApplications";
import ApplyForInvoicing from "@/views/MyElectronicPass/ApplyForInvoicing";
import DigitalPassApplication from "@/views/DigitalPassApplications/DigitalPassApplication/index.vue";
import ContinueToPay from "@/views/MyElectronicPass/ContinueToPay";
import useAuthnStore from "@/store/authn"
import Register from "@/views/Register";
import ApplyInvoice from "@/views/MyElectronicPass/ApplyInvoice";
import Loading from "@/views/LeoLogin/Loading";
//import StorePay from "@/views/Example/StorePay.vue";
import ConfirmPay from "@/views/ScanVerify/ConfirmPay";
import PayResult from "@/views/MyElectronicPass/PayResult";
import ChargeState from "@/views/ScanVerify/ChargeState";
import ProfitCenterPickerView from "@/views/Common/ProfitCenterPickerView.vue";
import DigitalPassApplicationsForm from "@/views/DigitalPassApplications/DigitalPassApplicationForm/index.vue";
import ConstructionLocationPickerView from "@/views/Common/ConstructionLocationPickerView.vue";
import LoginExpired from "@/views/LeoLogin/LoginExpired";
import VerifyRefer from "@/views/ScanVerify/VerifyRefer";
import VerifyGoodsInOutDetail from "@/views/ScanVerify/VerifyGoodsInOutDetail";
import VerifyGoodsInOutResult from "@/views/ScanVerify/VerifyGoodsInOutResult";
import LoginError from "@/views/ScanVerify/LoginError.vue";
import Cookies from 'js-cookie'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/userAgreement',
        name: 'userAgreement',
        component: UserAgreement,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/myElectronicPass',
        name: 'myElectronicPass',
        component: MyElectronicPass,
        meta: {
            title: '我的电子出入证',
            type: '/'
        }
    },
    // {
    //     path: '/myElectronicPass',
    //     name: 'myElectronicPass',
    //     component: MyElectronicPass,
    //     meta: {
    //         title: '我的电子出入证'
    //     }
    // },
    // {
    //     path: '/applyForAnElectronicPass',
    //     name: 'applyForAnElectronicPass',
    //     component: ApplyForAnElectronicPass,
    //     meta: {
    //         title: '我的电子出入证'
    //     }
    // },
    // {
    //     path: '/myElectronicPass',
    //     name: 'myElectronicPass',
    //     component: MyElectronicPass,
    //     meta: {
    //         title: '我的电子出入证'
    //     }
    // },
    // {
    //     path: '/applyForAnElectronicPass',
    //     name: 'applyForAnElectronicPass',
    //     component: ApplyForAnElectronicPass,
    //     meta: {
    //         title: '我的电子出入证'
    //     }
    // },

    // {
    //     path: '/myElectronicPass',
    //     name: 'myElectronicPass',
    //     component: MyElectronicPass,
    //     meta: {
    //         title: '我的电子出入证'
    //     }
    // },
    // {
    //     path: '/applyForAnElectronicPass',
    //     name: 'applyForAnElectronicPass',
    //     component: ApplyForAnElectronicPass,
    //     meta: {
    //         title: '我的电子出入证'
    //     }
    // },

    {
        path: '/scanVerify/scanVerify',
        name: 'scanVerify',
        component: ScanVerify,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/verifyRecord',
        name: 'verifyRecord',
        component: VerifyRecord,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/verifyRefer',
        name: 'verifyRefer',
        component: VerifyRefer,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/verifyResult',
        name: 'verifyResult',
        component: VerifyResult,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/verifyRecordDetail',
        name: 'verifyRecordDetail',
        component: VerifyRecordDetail,
        meta: {
            //title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/richScan',
        name: 'richScan',
        component: RichScan,
        meta: {
            title: '电子出入证',
            keepAlive: true,
            type: 'guard'
        }
    },
    {
        path: '/choiceProject/',
        name: 'choiceProject',
        component: ChoiceProject,
        meta: {
            title: '选择项目',
            type: 'guard'
        }
    },
    {
        path: '/digital-passes/applications/form',
        name: 'digital-passes-applications-form',
        component: DigitalPassApplicationsForm,
        meta: {
            title: '电子出入证申请',
            type: '/'
        }
    },
    {
        path: '/digital-passes/applications',
        name: 'digitalPassesApplications',
        component: DigitalPassApplications,
        meta: {
            title: '我的申请记录',
            type: '/'
        }
    },
    {
        path: '/digital-passes/applications/:applicationSituationId',
        name: 'digitalPassesApplication',
        component: DigitalPassApplication,
        meta: {
            title: '申请详情',
            type: '/'
        }
    },
    {
        path: '/digital-passes/applications/:applicationSituationId/form',
        name: 'digital-passes-application-form',
        component: DigitalPassApplicationsForm,
        meta: {
            title: '电子出入证申请',
            type: '/'
        }
    },
    // {
    //     path: '/digital-pass-applications/:applicationId/form',
    //     name: 'digital-pass-application-form',
    //     component: DigitalPassApplicationsForm,
    //     meta: {
    //         title: '电子出入证申请'
    //     }
    // },
    {
        path: '/leo-projects/:cheetahId/profit-centers/picker',
        name: 'leo-project-profit-centers-picker',
        component: ProfitCenterPickerView,
        meta: {
            title: '选择项目',
            type: '/'
        }
    },
    {
        path: '/profit-centers/picker',
        name: 'profit-centers-picker',
        component: ProfitCenterPickerView,
        meta: {
            title: '选择项目',
            type: '/'
        }
    },
    {
        path: '/leo-projects/:cheetahId/construction-locations/picker',
        name: 'leo-project-construction-locations-picker',
        component: ConstructionLocationPickerView,
        meta: {
            title: '选择施工位置',
            type: '/'
        }
    },
    {
        path: '/choiceSubject/',
        name: 'choiceSubject',
        component: ChoiceSubject,
        meta: {
            title: '选择计费科目',
            type: 'guard'
        }
    },
    {
        path: '/choiceSubSubject/',
        name: 'choiceSubSubject',
        component: ChoiceSubSubject,
        meta: {
            title: '选择子计费科目',
            type: 'guard'
        }
    },
    {
        path: '/constructionLocation/:applicationAttributeFieldTenantId',
        name: 'constructionLocation',
        component: ConstructionLocation,
        meta: {
            title: '选择施工位置',
            type: '/'
        }
    },
    {
        path: '/decorationPersonnelInformation',
        name: 'decorationPersonnelInformation',
        component: DecorationPersonnelInformation,
        meta: {
            title: '出入证个人资料',
            type: '/'
        }
    },
    {
        path: '/applyForInvoicing',
        name: 'applyForInvoicing',
        component: ApplyForInvoicing,
        meta: {
            title: '申请开票',
            type: '/'
        }
    },
    {
        path: '/continueToPay',
        name: 'continueToPay',
        component: ContinueToPay,
        meta: {
            title: '继续支付',
            type: '/'
        }
    },
    {
        path: '/payResult',
        name: 'payResult',
        component: PayResult,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/scanVerify/sporadicCharges',
        name: 'sporadicCharges',
        component: SporadicCharges,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/chargeCode',
        name: 'chargeCode',
        component: ChargeCode,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/chargePhone',
        name: 'chargePhone',
        component: ChargePhone,
        meta: {
            title: '零星收费',
            type: 'external'
        }
    },
    {
        path: '/scanVerify/chargeSporadicPay',
        name: 'chargeSporadicPay',
        component: ChargePay,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/chargePay',
        name: 'chargePay',
        component: ChargePay,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/scanVerify/chargeResult',
        name: 'chargeResult',
        component: ChargeResult,
        meta: {
            title: '电子出入证',
            type: 'external'
        }
    },
    {
        path: '/scanVerify/chargeInvoice',
        name: 'chargeInvoice',
        component: ChargeInvoice,
        meta: {
            title: '电子出入证',
            type: 'external'
        }
    },
    {
        path: '/scanVerify/confirmPay',
        name: 'confirmPay',
        component: ConfirmPay,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/scanVerify/confirmSporadicPay',
        name: 'confirmSporadicPay',
        component: ConfirmPay,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/scanVerify/chargeState',
        name: 'chargeState',
        component: ChargeState,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/tp/login',
        name: 'loading',
        component: Loading,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/tp/loginExpired',
        name: 'loginExpired',
        component: LoginExpired,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    // {
    //     path: '/myElectronicPass',
    //     name: 'myElectronicPass',
    //     component: MyElectronicPass,
    //     meta: {
    //         title: '我的电子出入证'
    //     }
    // },
    // {
    //     path: '/applyForAnElectronicPass',
    //     name: 'applyForAnElectronicPass',
    //     component: ApplyForAnElectronicPass,
    //     meta: {
    //         title: '我的电子出入证'
    //     }
    // },
    {
        path: '/applyInvoice',
        name: 'applyInvoice',
        component: ApplyInvoice,
        meta: {
            title: '电子出入证',
            type: '/'
        }
    },
    {
        path: '/scanVerify/verifyGoodsInOutDetail',
        name: 'verifyGoodsInOutDetail',
        component: VerifyGoodsInOutDetail,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/scanVerify/verifyGoodsInOutResult',
        name: 'verifyGoodsInOutResult',
        component: VerifyGoodsInOutResult,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
    {
        path: '/loginError',
        name: 'loginError',
        component: LoginError,
        meta: {
            title: '电子出入证',
            type: 'guard'
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    base: process.env.VUE_APP_ROUTER_BASE_URL,
    // base: '/h5/',
    routes
})

// const wecomLogin = () => {
//     const appid = process.env.VUE_APP_WECOM_APPID // CORPID
//     const redirectUri = window.location.href //'https://testvrobot.jinmaowy.com/wecom' // REDIRECT_URI
//     const scope = 'snsapi_base' // SCOPE
//     const agentid = process.env.VUE_APP_WECOM_AGENTID // AGENTID
//     // const state = 'mnjd93nso2q0=' // STATE
//     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize'
//         + '?appid=' + appid
//         + '&redirect_uri=' + redirectUri
//         + '&response_type=code'
//         + '&scope=' + scope
//         + '&agentid=' + agentid
//         + '&state=' + Math.floor(Math.random() * 100000000000) + '#wechat_redirect'
// }

router.beforeEach(async (to, from, next) => {
        // //beforeEach是router的钩子函数，在进入路由前执行
        if (to.meta.title) {
            //判断是否有标题
            document.title = to.meta.title
        } else {
            document.title = '电子出入证'
        }
        const tokenKey = 'Authorization';
        const loginType = 'loginType';
        // const userName = 'userName';
        const userPhone = 'userPhone';
        const title = 'title';
        const ignore = ['/', '/tp/login', '/tp/loginExpired', '/register', '/userAgreement', '/privacyPolicy', '/scanVerify/chargePhone','/loginError'
            // '/scanVerify/chargePay', '/scanVerify/chargeState', '/scanVerify/confirmPay', '/scanVerify/chargeResult', '/scanVerify/chargeInvoice'
        ];

        const authnStore = useAuthnStore();
        if (!authnStore.login && Cookies.get(tokenKey)) {
            authnStore.token({
                token: Cookies.get(tokenKey),
                user: {
                    loginType: Cookies.get(loginType),
                    // userName: Cookies.get(userName),
                    userPhone: Cookies.get(userPhone)
                },
            });
            Cookies.remove(tokenKey);
            Cookies.remove(loginType);
            Cookies.remove(userPhone);
        }
        if (Cookies.get(title)) {
            authnStore.token({
                title: Cookies.get(title),
            });
        }
        console.log(authnStore)
        if (ignore.includes(to.path) || authnStore.login) {
            next();
        } else if (!authnStore.login && authnStore.isLatestLoginTenant) {
            next('/tp/loginExpired');
        } else if(!authnStore.login && to.meta.type === 'guard'){
            next({
                path:'/',
                query: {
                    type: 'guard'
                 }
            });
        }else if(!authnStore.login && to.meta.type === 'external'){
            router.push({
                path: '/scanVerify/chargePhone',
                query: {
                    isInvoice: true
                }
            });
        }else{
            next('/');
        }

        // if (authnStore.login) {
        //     if (!to.query.authorization && from.query.authorization) {
        //         // to.query.authorization = from.query.authorization
        //         next({...to, query: from.query});
        //     } else {
        //         next();
        //     }
        //     return;
        // }
        //
        // if (to.query.authorization) {
        //     await authnStore.token(to.query.authorization)
        //     next()
        //     return;
        // }
        //
        // if (to.query.code) {
        //     const code = typeof to.query.code === 'object' ? to.query.code[0] : to.query.code;
        //     Toast.loading({
        //         message: `加载中...`,
        //         forbidClick: true,
        //         duration: 0,
        //     });
        //     authnStore.setCode(code);
        //     // alert(JSON.stringify(code))
        //     const codeRequest = {
        //         code: code,
        //     }
        //     // alert(JSON.stringify(codeRequest))
        //     client.post('/api/admin/sysUser/checkCode', codeRequest)
        //         .then(res => res.data.data?.accessToken)
        //         .then((token,) => {
        //             if (!token || token.length <= 0) {
        //                 return Promise.reject();
        //             }
        //             return authnStore.token(token);
        //         })
        //         .then(() => {
        //             Toast.clear();
        //             next({...to, name: 'home', query: {...to.query, code: undefined}})
        //         })
        //         .catch(({data}) => {
        //             if (data?.status === 203) {
        //                 Toast.fail('账号未激活');
        //             } else {
        //                 Toast.fail('登录失败,请刷新页面重试');
        //                 next({...to, name: 'home', query: {...to.query, code: undefined}})
        //             }
        //         })
        // } else {
        //     wecomLogin();
        // }
    }
)

router.afterEach(() => {
    // 重置滚动条到顶端
    document.body.scrollTop = 0
    //     // firefox
    document.documentElement.scrollTop = 0
})

// router.afterEach(() => {
//     // 重置滚动条到顶端
//     document.body.scrollTop = 0
//     // firefox
//     document.documentElement.scrollTop = 0

//     // Toast.loading({
//     //     message: `加载中...`,
//     //     forbidClick: true,
//     //     duration: 0,
//     // });
//     client.post('/api/admin/sysUser/getJsApiTicket', {url: location.href})
//         .then(({data}) => {

//             wx.error(function (res) {
//                 // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
//                 console.log(res)
//             });
//             wx.config({
//                 beta: true,// 调用wx.invoke形式的接口值时，该值必须为true。
//                 debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//                 appId: data.data.corpId, // 必填，企业微信的cropID
//                 timestamp: data.data.timestamp, // 必填，生成签名的时间戳
//                 nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
//                 signature: data.data.signature,// 必填，签名，见附录1
//                 jsApiList: data.data.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//             });
//         })
//     // .then(() => {
//     //     Toast.clear();
//     // })
// })

export default router
